import { render, staticRenderFns } from "./BrDictionaryItem.vue?vue&type=template&id=7537a63c&"
import script from "./BrDictionaryItem.vue?vue&type=script&lang=js&"
export * from "./BrDictionaryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports